import { render } from "./PrizesView.vue?vue&type=template&id=2ebe5260&scoped=true"
import script from "./PrizesView.vue?vue&type=script&lang=js"
export * from "./PrizesView.vue?vue&type=script&lang=js"

import "./PrizesView.vue?vue&type=style&index=0&id=2ebe5260&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ebe5260"]])

export default __exports__